/** Shown when a draft close or building move would overlap a sibling. */
export const BUILDING_OVERLAP_WARNING =
  'The building would overlap another building';

/** Shown when a GFA scale would overlap a sibling building. */
export const BUILDING_GFA_OVERLAP_WARNING =
  'Cannot apply GFA: the building would overlap another building';
